import m from "../../geodata/es2015/uzbekinstanLow";
window.am4geodata_uzbekinstanLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/uzbekinstanLow.js
// module id = null
// module chunks = 